import { Translator } from './translator'

export class Level{
    id:string
    titleEn:string
    titleKh:string
}